@if (section() === 'widget') {
<div
  class="flex overflow-x-auto lg:overflow-hidden gap-3 lg:gap-0 lg:bg-surface-card lg:rounded-xl mb-6 lg:mb-8 pb-1 lg:pb-0 no-scrollbar"
>
  @for (i of [1, 2, 3, 4]; track i) {
  <div
    class="flex items-center gap-4 p-4 rounded-xl bg-surface-card shrink-0 min-w-60 lg:flex-1 lg:px-5 lg:py-4 lg:rounded-none lg:bg-transparent"
  >
    <div class="size-14 rounded-full overflow-hidden shrink-0"><dss-libs-ui-skeleton /></div>
    <div class="flex flex-col gap-2">
      <div class="h-7 w-14 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
      <div class="h-4 w-24 rounded overflow-hidden"><dss-libs-ui-skeleton /></div>
    </div>
  </div>
  @if (!$last) {
  <div class="hidden lg:block w-px h-14 bg-stroke-soft my-auto shrink-0"></div>
  } }
</div>
} @else {
<dss-libs-ui-table-skeleton [columns]="tableColumns" />
}
